<template>
  <BForm
    class="formulario"
    @submit.prevent="gravar">
    <InputBasico
      ref="inputNome"
      type="text"
      name="inputNome"
      label="Nome*"
      class="input__nome"
      v-model="form.nome"
      v-validate="'required|min:3'"
      :errorsBag="errors"
    />

    <InputCelular
      name="inputContato"
      label="Contato*"
      placeholder="Ex. WhatsApp"
      class="input__contato"
      v-model="form.contato"
      v-validate="'required|minLenTel'"
      :errorsBag="errors"
    />

    <InputBasico
      type="text"
      name="inputRedeSocial"
      label="Instagram"
      class="input__redesocial"
      placeholder="Ex. sr.n_barbearia"
      v-model="form.redesocial"
    />

    <div class="botao__container">
      <BButton
        type="submit"
        class="botao"
        variant="primary">
        Gravar
      </BButton>

      <BButton
        @click.prevent="sair"
        class="botao"
        variant="outline-primary">
        Sair
      </BButton>
    </div>
  </BForm>
</template>

<script>
import { BForm, BButton } from 'bootstrap-vue/es/components'
import FormularioCadastroMixin from '@/mixins/FormularioCadastroMixin'
import InputBasico from '@/components/inputs/InputBasico.vue'
import InputCelular from '@/components/inputs/pessoais/InputCelular.vue'

export default {
  name: 'UsuariosCadastroForm',
  mixins: [FormularioCadastroMixin],
  components: {
    BForm,
    BButton,
    InputBasico,
    InputCelular,
  },
  mounted() {
    this.$refs.inputNome.focar()
  },
  methods: {
    valoresIniciaisForm() {
      return {
        nome: '',
        contato: '',
        redesocial: '',
      }
    },
    retornaCamposGravar() {
      return this.form
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

.formulario {
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: $small-size) {
    width: 100%;
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 0.8em;
  }

  @media (min-width: $extra-large-size) {
    width: $medium-size;
  }
}

.input {
  &__nome {
    @media (min-width: $small-size) {
      grid-column: 1 / -1;
    }

    @media (min-width: $medium-size) {
      grid-column: 1 / 9;
    }
  }

  &__contato {
    @media (min-width: $small-size) {
      grid-column: 1 / 7;
    }

    @media (min-width: $medium-size) {
      grid-column: 9 / -1;
    }
  }

  &__redesocial {
    @media (min-width: $small-size) {
      grid-column: 7 / -1;
    }

    @media (min-width: $medium-size) {
      grid-column: 1 / 5;
    }
  }

}

.botao {
  margin-left: .2rem;

  &__container {
    margin-top: 1rem;
    grid-column: 1 / -1;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
  }
}

</style>
